import { render, staticRenderFns } from "./CustomerTransfer.vue?vue&type=template&id=0484492a&scoped=true"
import script from "./CustomerTransfer.vue?vue&type=script&lang=js"
export * from "./CustomerTransfer.vue?vue&type=script&lang=js"
import style0 from "./CustomerTransfer.vue?vue&type=style&index=0&id=0484492a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0484492a",
  null
  
)

export default component.exports